import type { IStorageService } from '@/interfaces'

class CookieStorageService implements IStorageService {
  itemName: string

  itemValue: string

  itemExpiryDate?: string

  itemExpirySeconds?: number

  constructor() {
    this.itemName = ''
    this.itemValue = ''
    this.itemExpiryDate = ''
    this.itemExpirySeconds = 0
  }

  public getData(itemName: string) {
    this.itemName = itemName

    try {
      const cookieName = `${this.itemName}=`
      const decodedCookie = decodeURIComponent(document.cookie)
      const cookiesArray = decodedCookie.split(';')
      for (let i = 0; i < cookiesArray.length; i++) {
        let cookieString = cookiesArray[i]
        while (cookieString.charAt(0) === ' ') {
          cookieString = cookieString.substring(1)
        }
        if (cookieString.indexOf(cookieName) === 0) {
          return cookieString.substring(cookieName.length, cookieString.length)
        }
      }
      return ''
    } catch (e) {
      throw new Error(`Failed to get item ${this.itemName}: ${e}`)
    }
  }

  public setData(itemName: string, itemValue: string, itemExpirySeconds: number) {
    this.itemName = itemName
    this.itemValue = itemValue
    this.itemExpirySeconds = itemExpirySeconds

    try {
      const expires = `Max-Age=${this.itemExpirySeconds}`
      document.cookie = `${this.itemName}=${this.itemValue}; ${expires}; Path=/; SameSite=Strict;`
    } catch (e) {
      throw new Error(`Failed to set item ${this.itemName}: ${e}`)
    }
  }

  public updateData(itemName: string) {
    this.itemName = itemName
    throw new Error('Method not implemented.')
  }

  public removeData(itemName: string): void {
    this.itemName = itemName

    try {
      document.cookie = `${this.itemName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    } catch (e) {
      throw new Error(`Failed to delete item ${this.itemName}: ${e}`)
    }
  }

  public checkData(itemName: string, itemValue: string) {
    this.itemName = itemName
    this.itemValue = itemValue

    try {
      return this.getData(this.itemName) === this.itemValue
    } catch (e) {
      throw new Error(`Failed to check item: ${itemName}`)
    }
  }

  clearCookies() {
    const cookies = document.cookie.split(';').map((item) => item.split('=')[0])
    cookies.forEach((cookie) => this.removeData(cookie))
  }
}

export default CookieStorageService
